import { render, staticRenderFns } from "./UserManagementIcon.vue?vue&type=template&id=82c9bb8e&"
import script from "./UserManagementIcon.vue?vue&type=script&lang=js&"
export * from "./UserManagementIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports